import {useSelector} from 'react-redux';

import flowAvailabilityService from '@/services/aem/flowAvailabilityService';
import deviceConnectionService from '@/services/device/deviceConnectionService';
import userBrowserService from '@/services/user/userBrowserService';
import {selectDeviceType, selectIsSelectedDeviceConnected} from '@/state/selectors/device';

export const useConnectionFlow = () => {
    const deviceType = useSelector(selectDeviceType);
    const isSelectedDeviceConnected = useSelector(selectIsSelectedDeviceConnected);

    if (isSelectedDeviceConnected) {
        return {
            showConnectButton: false,
            showDownloadChromeButton: false,
        };
    }

    // iOS devices can always connect
    const isIosDevice = userBrowserService.isIosDevice();

    if (isIosDevice) {
        return {
            showConnectButton: true,
            showDownloadChromeButton: false,
        };
    }

    const isConnectionEnabled = flowAvailabilityService.isConnectionEnabled();
    const isConnectionAvailable = deviceConnectionService.isConnectionAvailable(deviceType);
    const isTrustedBrowser = userBrowserService.isBrowserTrusted();
    //isConnectionEnabled = physical connect is not available so redirect to webapp should be available
    const canConnectDevice = isTrustedBrowser && (!isConnectionEnabled || isConnectionAvailable);

    return {
        showConnectButton: canConnectDevice,
        showDownloadChromeButton: !isTrustedBrowser,
    };
};
